import { render, staticRenderFns } from "./ReleaseModalForm.vue?vue&type=template&id=3337ce4c"
import script from "./ReleaseModalForm.vue?vue&type=script&lang=js"
export * from "./ReleaseModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports